import { useState } from "react";
import ImagesImportContainer from "../../../components/ImagesImportContainer/ImagesImportContainer";
import Input from "../../../components/Input/Input";
import { useFastCondoUserStore } from "./context";
import ToggleButton from "../../../components/ToggleButton/ToggleButton";
import { useUserStore } from "../../../contexts/userStore";
import { useTranslation } from "react-i18next";
import { LuSearch } from "react-icons/lu";

export function UserDataStep({ ...props }) {
   const { t } = useTranslation();
   const {
      urlImg,
      name,
      cpf,
      rg,
      phoneNumber,
      plate,
      description,
      createUser,
      errors,
      isSubmitting,
      update,
      findUser,
      isLoadindUser,
      id,
   } = useFastCondoUserStore();
   const { selectedCondominioObj } = useUserStore();

   return (
      <div className="flex flex-row gap-10 pl-6! pr-0!">
         <ImagesImportContainer
            setUrlImg={(url) => update("urlImg", url)}
            onFileChanged={(file) => update("photoFile", file)}
            urlImg={urlImg}
            onlyImage={true}
            showButtonLabels={false}
            disabled={isSubmitting}
         />
         <div className="grid grid-cols-2 h-fit auto-rows-[62px] gap-5 pt-1! flex-1">
            <Input
               name="name"
               id="name"
               labelText={t("common.name") + " *"}
               value={name}
               onChange={({ target }) => {
                  const newValue = target.value.replace(/[0-9]/g, "");
                  update("name", newValue);
               }}
               tooltipText={t("monitoring.inputNameHelpText")}
               tooltipVisible={true}
               required={false}
               error={errors.name.join('. ')}
               disabled={isSubmitting}
            />
            <Input
               name={"phone_number"}
               id="phone_number"
               labelText={t("common.phoneNumber")}
               value={phoneNumber}
               onChange={({ target }) => update("phoneNumber", target.value)}
               required={false}
               placeholder="(00) 00000-0000"
               showPhoneMask={true}
               minLength={"15"}
               maxLength={"15"}
               tooltipText={t("monitoring.inputPhoneHelpText")}
               tooltipVisible={true}
               error={errors.phoneNumber.join('. ')}
               disabled={isSubmitting}
            />
            <div className="flex w-full relative">
               <Input
                  name={"cpf"}
                  id="cpf"
                  labelText={"CPF"}
                  value={cpf}
                  onChange={({ target }) => update("cpf", target.value)}
                  minLength={"14"}
                  maxLength={"14"}
                  showCpfCnpjMask={true}
                  showCpfMask={true}
                  placeholder="000.000.000-00"
                  tooltipText={t("monitoring.inputCpfHelpText")}
                  tooltipVisible={true}
                  error={errors.cpf.join('. ')}
                  disabled={isSubmitting}
               />
               <button
                  type="button"
                  disabled={isLoadindUser}
                  className="text-(--textColor)! text-xs! px-3! py-1.5! bg-(--borderColor)/60! hover:bg-(--borderColor)! duration-200 absolute right-1.5 bottom-[6px] rounded-(--borderRadius)"
                  onClick={(e) => findUser(cpf)}
               >
                  <span className="inline-flex gap-1.5 items-center">
                     <LuSearch size={14} />
                     Buscar
                  </span>
               </button>
            </div>
            <Input
               type="number"
               name="rg"
               id="rg"
               labelText="RG"
               value={rg}
               onChange={({ target }) => update("rg", target.value)}
               required={false}
               maxLength={"10"}
               tooltipText={t("monitoring.inputRgHelpText")}
               tooltipVisible={true}
               error={errors.rg.join('. ')}
               disabled={isSubmitting}
            />
            <Input
               name="plate"
               id="plate"
               labelText={t("common.plate")}
               value={plate}
               onChange={({ target }) =>
                  update("plate", target.value)
               }
               required={false}
               tooltipText={t("monitoring.inputPlateHelpText")}
               tooltipVisible={true}
               error={errors.plate.join('. ')}
               disabled={isSubmitting}
            />
            <Input
               name="description"
               id="description"
               labelText={t("common.observations")}
               value={description}
               onChange={({ target }) =>
                  update("description", target.value)
               }
               required={false}
               tooltipText={t("monitoring.inputObservationsHelpText")}
               tooltipVisible={true}
               disabled={isSubmitting}
            />
            <ToggleButton
               label={!!id ? "Atualizar usuário" : t("monitoring.registerUser")}
               defaultChecked={createUser}
               onChange={({ target }) => update("createUser", target.checked)}
               required={false}
               tooltipText={!!id ? "Marque esta opção para atualizar o usuário em questão." : t("monitoring.inputRegisterUserHelpText", { name: selectedCondominioObj?.name })}
               tooltipVisible={true}
               disabled={isSubmitting || (!!id && createUser)}
            />
         </div>
      </div>
   );
}
